import React, { Component } from 'react'
import styles from './styles.scss'

import { TweenMax, Power3, Expo } from 'gsap'
import components from 'src/utils/components'
import values from 'src/values'
import config from 'src/config'

export default class Links extends Component {
  onClick(link) {
    if (link) {
      window.open(link, '_blank')
    } else {
      components.allComponents.home.showWeChat()
    }
  }

  onMouseEnter(i) {
    values.viewport.width > config.bp.md &&
      TweenMax.to(this.refs[`link${i}`], 0.5, { x: -5, ease: Expo.easeOut })
  }

  onMouseLeave(i) {
    values.viewport.width > config.bp.md &&
      TweenMax.to(this.refs[`link${i}`], 0.5, { x: 0, ease: Expo.easeOut })
  }

  render() {
    return (
      <div ref="component" className="component links-wrapper">
        {this.props.links.map((link, i) => {
          return (
            <div
              onClick={this.onClick.bind(this, link.url)}
              onMouseEnter={this.onMouseEnter.bind(this, i)}
              onMouseLeave={this.onMouseLeave.bind(this, i)}
              key={`link${i}`}
              ref={`link${i}`}
              className={`link-container link-${i}`}>
              <img src={`${process.env.PUBLIC_URL}/img/${link.logo}`} />
            </div>
          )
        })}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Home/components/footer/components/links/index.js